import { createAction } from '@reduxjs/toolkit';

import type {
  ConnectIntegrationCommand,
  DisableIntegrationCommand,
  DisconnectIntegrationCommand,
  EnableIntegrationCommand,
  UpdateIntegrationFunctionsCommand,
} from './integration.commands';

export const PREFIX = 'integrations';

export const connectIntegration = createAction<ConnectIntegrationCommand>(
  `${PREFIX}/connect`,
);

export const disconnectIntegration = createAction<DisconnectIntegrationCommand>(
  `${PREFIX}/disconnect`,
);

export const enableIntegration = createAction<EnableIntegrationCommand>(
  `${PREFIX}/enable`,
);

export const disableIntegration = createAction<DisableIntegrationCommand>(
  `${PREFIX}/disable`,
);

export const updateIntegrationFunctions =
  createAction<UpdateIntegrationFunctionsCommand>(`${PREFIX}/updateFunctions`);
